/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_F_Icon1Inputs */

const vi_sitesettings_f_icon1 = /** @type {(inputs: Sitesettings_F_Icon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biểu tượng`)
};

/**

* @param {Sitesettings_F_Icon1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_f_icon1 = /** @type {((inputs?: Sitesettings_F_Icon1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_F_Icon1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_f_icon1(inputs)
});
export { sitesettings_f_icon1 as "siteSettings_f_icon" }